import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../baseQueryWithReauth";
import { serializeArgsWithoutToken } from "../serializeQueryArgs";

export const hardwareApi = createApi({
  reducerPath: "hardware",
  tagTypes: ["Hardware"],
  baseQuery: baseQueryWithReauth,
  serializeQueryArgs: serializeArgsWithoutToken, // #142: token önbellek anahtarına girmez
  keepUnusedDataFor: 120,
  endpoints(builder) {
    return {
      // Tum hardware (kart firmware) versiyonlarini listele
      getHardwareVersions: builder.query({
        query: (token) => ({
          url: "/api/hardware-update/versions",
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        }),
        providesTags: ["Hardware"],
      }),

      // Presigned upload URL al
      getHardwarePresignedUploadUrl: builder.mutation({
        query: ({ token, cardType, version }) => ({
          url: "/api/hardware-update/upload/presign",
          method: "POST",
          headers: { Authorization: `Bearer ${token}` },
          body: { cardType, version },
        }),
      }),

      // Upload tamamlandiktan sonra DB kaydi olustur
      confirmHardwareUpload: builder.mutation({
        query: ({
          token,
          storageKey,
          cardType,
          cardLabel,
          modelNo,
          chip,
          version,
          versionCode,
          checksum,
          files,
          fileSize,
          sha256Hash,
          notes,
        }) => ({
          url: "/api/hardware-update/upload/confirm",
          method: "POST",
          headers: { Authorization: `Bearer ${token}` },
          body: {
            storageKey,
            cardType,
            cardLabel,
            modelNo,
            chip,
            version,
            versionCode,
            checksum,
            files,
            fileSize,
            sha256Hash,
            notes,
          },
        }),
        invalidatesTags: ["Hardware"],
      }),

      // Hardware paketi icin indirme URL'i al
      getHardwareDownloadUrl: builder.query({
        query: ({ token, id }) => ({
          url: `/api/hardware-update/${id}/download`,
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        }),
      }),

      // Hardware versiyonunu sil (DB + storage)
      deleteHardwareVersion: builder.mutation({
        query: ({ token, id }) => ({
          url: `/api/hardware-update/${id}`,
          method: "DELETE",
          headers: { Authorization: `Bearer ${token}` },
        }),
        invalidatesTags: ["Hardware"],
      }),
    };
  },
});

export const {
  useGetHardwareVersionsQuery,
  useLazyGetHardwareVersionsQuery,
  useGetHardwarePresignedUploadUrlMutation,
  useConfirmHardwareUploadMutation,
  useLazyGetHardwareDownloadUrlQuery,
  useDeleteHardwareVersionMutation,
} = hardwareApi;
